// iOS Safari cart drawer scroll fix
// Override body-scroll-lock behavior to allow scrolling in cart__scrollable

(function() {
  // Wait for drawer to open
  document.addEventListener('drawerOpen', function() {
    setTimeout(function() {
      const drawer = document.querySelector('.site-header__cart.is-active');
      const scrollable = drawer ? drawer.querySelector('.cart__scrollable') : null;
      
      if (!scrollable) return;
      
      // Allow touch events to pass through to scrollable element
      let touchStartY = 0;
      
      scrollable.addEventListener('touchstart', function(e) {
        touchStartY = e.touches[0].clientY;
      }, { passive: false });
      
      scrollable.addEventListener('touchmove', function(e) {
        const touchY = e.touches[0].clientY;
        const scrollTop = scrollable.scrollTop;
        const scrollHeight = scrollable.scrollHeight;
        const height = scrollable.clientHeight;
        const atTop = scrollTop <= 0;
        const atBottom = scrollTop + height >= scrollHeight;
        
        // Allow scrolling if not at boundaries
        if (!atTop && !atBottom) {
          e.stopPropagation();
          return;
        }
        
        // At top, only allow scrolling down
        if (atTop && touchY < touchStartY) {
          e.stopPropagation();
          return;
        }
        
        // At bottom, only allow scrolling up
        if (atBottom && touchY > touchStartY) {
          e.stopPropagation();
          return;
        }
        
        // Prevent body scroll at boundaries
        e.preventDefault();
      }, { passive: false });
    }, 100);
  });
})();
